import { createDatabaseMigrationPath, isDatabaseMigrationFile } from '@bolt/supabase-utils/migrations';
import { timeZoneToSupabaseRegion } from './supabase-region';
import { availableRegions } from '~/lib/data/supabase';
import type { SupabaseProject, SupabaseRegion } from '~/types/supabase';
import { stripIndents } from '~/utils/stripIndent';

const TITLE_REGEX = /\s*#\s*(.+)/;

export { createDatabaseMigrationPath, isDatabaseMigrationFile };

export function extractQueryParts(fileContent: string) {
  const { start, end, hasSummary } = findSummaryBounds(fileContent);

  let title = '';
  let summary = hasSummary ? fileContent.slice(start + 2, end) : fileContent.slice(0, 100) + '...';

  if (hasSummary) {
    const titleMatch = summary.match(TITLE_REGEX);

    title = titleMatch ? titleMatch[1].trim() : '';

    if (titleMatch && typeof titleMatch.index !== 'undefined') {
      summary = stripIndents(summary.slice(titleMatch.index + titleMatch[0].length)).trim();
    }
  }

  const query = hasSummary ? fileContent.slice(end + 2) : fileContent;

  return { title, summary, query };
}

function findSummaryBounds(sqlFileContent: string) {
  const summaryStart = sqlFileContent.indexOf('/*');
  const summaryEnd = sqlFileContent.indexOf('*/', summaryStart + 2);

  return {
    start: summaryStart,
    end: summaryEnd,
    hasSummary: summaryStart !== -1 && summaryEnd !== -1,
  };
}

export function sortProjectsByStatus(a: SupabaseProject, b: SupabaseProject): number {
  if (a.status === 'INACTIVE' && b.status !== 'INACTIVE') {
    return 1;
  }

  if (a.status !== 'INACTIVE' && b.status === 'INACTIVE') {
    return -1;
  }

  if (a.status === 'ACTIVE_HEALTHY' && b.status !== 'ACTIVE_HEALTHY') {
    return -1;
  }

  if (a.status !== 'ACTIVE_HEALTHY' && b.status === 'ACTIVE_HEALTHY') {
    return 1;
  }

  return 0;
}

export function getClosestRegion() {
  const closestRegionId = getClosestRegionId();

  return availableRegions.find((region) => region.id === closestRegionId) || availableRegions[0];
}

export function getClosestRegionId(): SupabaseRegion {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return timeZoneToSupabaseRegion(timezone);
  } catch {
    return 'us-east-1';
  }
}
